/**
 * Scrap API Client
 * Epic 65: Selejtezés & Készletkorrekció
 */

import { api } from './client';

// ============================================
// TYPES
// ============================================

export interface ScrapRecord {
  id: string;
  tenantId: string;
  inventoryItemId: string;
  productId: string;
  warehouseId: string;
  quantity: number;
  reason: 'DAMAGED' | 'EXPIRED' | 'DEFECTIVE' | 'OTHER';
  note?: string;
  photoUrl?: string;
  unitValue?: number;
  totalValue?: number;
  scrapReportId?: string;
  createdBy: string;
  createdAt: string;
}

export interface ScrapRecordQueryResult {
  records: ScrapRecord[];
  total: number;
  offset: number;
  limit: number;
}

export interface ScrapReport {
  id: string;
  tenantId: string;
  year: number;
  month: number;
  status: 'DRAFT' | 'APPROVED' | 'FINALIZED';
  totalItems: number;
  totalValue: number;
  approvedBy?: string;
  approvedAt?: string;
  finalizedBy?: string;
  finalizedAt?: string;
  createdBy: string;
  createdAt: string;
}

export interface ScrapReportQueryResult {
  reports: ScrapReport[];
  total: number;
  offset: number;
  limit: number;
}

// ============================================
// API CALLS
// ============================================

export async function createScrapRecord(data: {
  inventoryItemId: string;
  productId: string;
  warehouseId: string;
  quantity: number;
  reason: string;
  note?: string;
  photoUrl?: string;
  unitValue?: number;
}) {
  return api.post<{ data: ScrapRecord }>('/scrap', data);
}

export async function listScrapRecords(params?: {
  warehouseId?: string;
  productId?: string;
  reason?: string;
  offset?: number;
  limit?: number;
}) {
  const query = new URLSearchParams();
  if (params?.warehouseId !== undefined) query.set('warehouseId', params.warehouseId);
  if (params?.productId !== undefined) query.set('productId', params.productId);
  if (params?.reason !== undefined) query.set('reason', params.reason);
  if (params?.offset !== undefined) query.set('offset', String(params.offset));
  if (params?.limit !== undefined) query.set('limit', String(params.limit));
  const qs = query.toString();
  return api.get<{ data: ScrapRecordQueryResult }>(`/scrap${qs ? `?${qs}` : ''}`);
}

export async function listScrapProtocols(params?: {
  year?: number;
  month?: number;
  status?: string;
}) {
  const query = new URLSearchParams();
  if (params?.year !== undefined) query.set('year', String(params.year));
  if (params?.month !== undefined) query.set('month', String(params.month));
  if (params?.status !== undefined) query.set('status', params.status);
  const qs = query.toString();
  return api.get<{ data: ScrapReportQueryResult }>(`/scrap/protocols${qs ? `?${qs}` : ''}`);
}

export async function createScrapProtocol(data: { year: number; month: number }) {
  return api.post<{ data: ScrapReport }>('/scrap/protocols', data);
}

export async function approveScrapProtocol(id: string) {
  return api.patch<{ data: ScrapReport }>(`/scrap/protocols/${id}/approve`, {});
}

export async function finalizeScrapProtocol(id: string) {
  return api.patch<{ data: ScrapReport }>(`/scrap/protocols/${id}/finalize`, {});
}
